import { Request } from '../../../httpClient/serverApi/requests/Request';
import {IResult} from '../../../httpClient/serverApi/types/IResponse';

export interface IGetHasAnalyticsExtensionTableParams {
  // the ID of the workbook that we are checking for analytics Extension Tables
  id: string;
}

export interface IGetHasAnalyticsExtensionTableResult extends IResult{}

export class GetHasAnalyticsExtensionTableRequest extends Request<IGetHasAnalyticsExtensionTableParams, IGetHasAnalyticsExtensionTableResult> {
  constructor(params: IGetHasAnalyticsExtensionTableParams) {
    super('getHasAnalyticsExtensionTable', params);
  }
}
